import Telemetry from '@atlassian/mpac-telemetry';
import { useEffect } from 'react';
import { HomePageTask, ViewHomeEnterpriseSection, viewHomeEnterpriseSectionTask, ViewHomeSections, viewHomeSectionTask } from './tasks';
export const useHomePageTelemetry = _ref => {
  let {
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    enterpriseAppsSectionDataError,
    sectionsDataError
  } = _ref;
  useEffect(() => {
    HomePageTask.start();
    ViewHomeEnterpriseSection.start();
  }, []);
  useEffect(() => {
    if (isEnterpriseAppsSectionLoading) {
      ViewHomeEnterpriseSection.start();
    }
  }, [isEnterpriseAppsSectionLoading]);
  useEffect(() => {
    if (isEnterpriseAppsSectionLoadError) {
      Telemetry.setUFOInteractionError({
        name: viewHomeEnterpriseSectionTask,
        errorMessage: enterpriseAppsSectionDataError
      });
      ViewHomeEnterpriseSection.failed(enterpriseAppsSectionDataError);
    }
    if (enterpriseAppsSectionData) {
      ViewHomeEnterpriseSection.succeeded();
    }
  }, [isEnterpriseAppsSectionLoadError, enterpriseAppsSectionData, enterpriseAppsSectionDataError]);
  useEffect(() => {
    if (areSectionsLoading) {
      ViewHomeSections.start();
    }
    if (isSectionsLoadError) {
      Telemetry.setUFOInteractionError({
        name: viewHomeSectionTask,
        errorMessage: sectionsDataError
      });
      ViewHomeSections.failed(sectionsDataError);
    }
    if (sectionsData) {
      ViewHomeSections.succeeded();
    }
  }, [areSectionsLoading, isSectionsLoadError, sectionsData, sectionsDataError]);
};